import { render, staticRenderFns } from "./OsvCard.vue?vue&type=template&id=92edb92e&scoped=true&"
import script from "./OsvCard.vue?vue&type=script&lang=js&"
export * from "./OsvCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92edb92e",
  null
  
)

export default component.exports